module.exports = __webpack_public_path__ + "static/media/antontanderup.a6030dbd.jpeg";